export const adaptDiagnosticoCIE = (diagnostico) => {
    return {
        codigo: diagnostico?.cod_DiagnosticoCIE,
        diagnostico: diagnostico?.descripcion
    }
}

export const adaptDiagnosticoCIEArray = (
    diagnosticos
) => {
    return structuredClone(diagnosticos?.allDiagnosticoCIE?.items)
        ?.map(diagnostico => adaptDiagnosticoCIE(diagnostico));
}


export const adaptDiagnosticoItem = (diagnostico) => {
    return {
        codigo: diagnostico?.cod_DiagnosticoCIEItem,
        descripcion: diagnostico?.descripcion,
        codigoDiagnostico: diagnostico?.cod_DiagnosticoCIE,
        categoria: diagnostico?.cod_DiagnosticoCIENavigation?.descripcion,
    }
}

export const adaptDiagnosticoItemsArray = (
    diagnosticos
) => {
    return structuredClone(diagnosticos?.allDiagnosticoCIEItems?.items)
        ?.map(diagnostico => adaptDiagnosticoItem(diagnostico));
}